export const isHexBlack = (hexColor: string, blackLimit = 55) => {
  const hexColorRegex = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

  if (!hexColorRegex.test(hexColor)) {
    throw new Error(`Invalid hex color ${hexColor}. Expected format is #RRGGBB or #RGB`);
  }

  const normalizedHexColor =
    hexColor.length === 4
      ? `#${hexColor[1]}${hexColor[1]}${hexColor[2]}${hexColor[2]}${hexColor[3]}${hexColor[3]}`
      : hexColor;

  const r = Number.parseInt(normalizedHexColor.substring(1, 3), 16);
  const g = Number.parseInt(normalizedHexColor.substring(3, 5), 16);
  const b = Number.parseInt(normalizedHexColor.substring(5, 7), 16);

  return r <= blackLimit && g <= blackLimit && b <= blackLimit;
};
